import styled from "styled-components";

export const StandardShadow = styled.div`
  box-shadow: 0.4rem 0.4rem black;
  background-color: black;
  border-radius: ${(props) => props.borderRadius};
`;
